// ============================================
// Config del cliente
// ============================================
// API_URL apunta al backend Express.
//
// - En desarrollo local: gracias al "proxy" en client/package.json,
//   las llamadas relativas (/api/...) las redirige CRA a localhost:3001.
//   Aun así dejamos un default explícito por seguridad.
// - En producción (Vercel): se inyecta REACT_APP_API_URL en build time
//   apuntando al backend de Railway, ej: https://api.sonrieglobos.com
//
// IMPORTANTE: las variables REACT_APP_* solo se leen en build, no en runtime.
// Si la cambias en Vercel hay que rebuild.
//
// API_URL nunca debe terminar en "/". Las rutas siempre arrancan con "/api/...".

const raw = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const API_URL = raw.replace(/\/+$/, ''); // quita trailing slashes
